/* story-drop.js — smooth-scroll anchor nav only */
(function () {
  document.querySelectorAll('a[href^="#sd-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
